import * as React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import IconService from '../../../../../Services/IconService';
import CarsGroupCell from '../carsGroupCell';
import Config from '../../../../../../config';

const GroupItem = SortableElement((thisItem: any) => (
  <div
    style={{
      borderBottom: '1px solid #cccccc',
      background: '#D2E2FD',
      paddingTop: '13px',
    }}
    key={`item-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
    id={`item-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
    className={`${thisItem.item.active} hover-off d-flex flex-row flex-wrap d-lg-table-row d-md-table-row`}
    draggable={true}
    data-cy="groupItem"
  >
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell font-weight-bold px-2 text-nowrap col-10 col-md-auto order-2">
      <div
        title={thisItem.intl.formatMessage({
          id: `navigator.car.${
            Config.Vehicle.typeName[thisItem.item.vehicleTypeId] === undefined
              ? 'car'
              : Config.Vehicle.typeName[thisItem.item.vehicleTypeId]
          }`,
        })}
        style={{ marginRight: '15px' }}
      >
        <svg
          width="20px"
          height="20px"
          viewBox="10 5 30 30"
          version="1.1"
          className="rotate90"
          style={{
            float: 'left',
            marginRight: '10px',
            marginLeft: '-5px',
            position: 'relative',
            top: '4px',
          }}
        >
          <path
            id="path"
            d={IconService.getPath(thisItem.item.vehicleTypeId)}
            fill="#000"
            fillOpacity="1"
            stroke="none"
          />
        </svg>
        <CarsGroupCell
          name={thisItem.item.name}
          id={`group-name-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
          allGroupsString={thisItem.allGroupsString}
          vehicleString={thisItem.vehicleString}
          isSeachable={true}
        />
      </div>
    </div>
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell px-3 col-auto order-3">
      <CarsGroupCell
        name={thisItem.item.licenceNumber}
        id={`group-licence-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
        allGroupsString={thisItem.allGroupsString}
        vehicleString={thisItem.vehicleString}
        isSeachable={true}
      />
    </div>
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell px-2 col col-md-auto order-4">
      {thisItem.item.driverName && (
        <CarsGroupCell
          name={thisItem.item.driverName}
          id={`group-driver-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
          allGroupsString={thisItem.allGroupsString}
          vehicleString={thisItem.vehicleString}
          isSeachable={true}
        />
      )}
    </div>
    <div className="e-table-cell d-block d-lg-table-cell d-md-table-cell px-3 col-auto order-5">
      <CarsGroupCell
        name={thisItem.item.customerName}
        id={`group-customer-${thisItem.thisGroup}-${thisItem.item.vehicleId}`}
        allGroupsString={thisItem.allGroupsString}
        vehicleString={thisItem.vehicleString}
        isSeachable={true}
      />
    </div>
    <div
      style={{ cursor: 'pointer' }}
      className="d-block d-lg-table-cell d-md-table-cell px-1 text-center col-2 col-md-auto order-1 right-side"
    >
      <span
        title=""
        data-cy={`cars-group-arrow-assigned-${thisItem.item.name}`}
        className="text-decoration-none text-gray"
      >
        <i className="cmd-icon cmd-icon-arrow-left-2 d-none d-md-inline-block" />
      </span>
    </div>
  </div>
));

export default GroupItem;
